export default {"src":"/_next/static/media/box-puptainer.964c4f6f.svg","height":66,"width":106,"blurWidth":0,"blurHeight":0};